class Enum {
    static GetAll(){
        let ris = [];
        for(let p in this){
            ris.push(this[p]);
        }
        return ris;
    }
    static GetDictionary(){
        let ris = {};
        for(let p in this){
            ris[p] = this[p];
        }
        return ris;
    }
}

export class DataTypes extends Enum
{
    static Boolean: string = "boolean";
    static Date: string = "date";
    static Float: string = "float";
    static Integer: string = "integer";
    static String: string = "string";
    static MultiSelect: string = "multiselect";
    static Singleselect: string = "singleselect";
    static ReadNumberDigitsOnly: string = "ReadNumberDigitsOnly";
}

export class DataFromApi extends Enum
{
    static clienti: string = "clienti";
    static immobili: string = "immobili";
    static attivita: string = "attivita";
    static task: string = "task";
    static user: string = "user";
    static gruppi: string = "gruppi";
    static appuntamenti: string = "appuntamenti";
}